import { reactive } from '@/core/reactive/reactive';
import { LoginConfig } from '@/core/config';
import { PasswordClient } from '@/core/reactive/services/sdk';

export const PasswordService = reactive.service(
  'password',
  PasswordClient,
)(Service => new Service(LoginConfig.current?.api?.host ?? ''));
